import * as tslib_1 from "tslib";
import { CacheKey } from '../constants/cachekey.constants';
export class FeatureCanActivateGuard {
    constructor(_authService, _router, _cacheService) {
        this._authService = _authService;
        this._router = _router;
        this._cacheService = _cacheService;
    }
    canActivate(route, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // console.log(route.data['privileges']);
            let hasAccess = true;
            yield this._authService.hasPrivilege(route.data['privileges'])
                .then((res) => {
                hasAccess = true;
            });
            return new Promise((resolve, reject) => {
                if (!hasAccess) {
                    this.redirectToNotFoundPage(state.url);
                }
                resolve(hasAccess);
            });
        });
    }
    redirectToNotFoundPage(returnUrl) {
        let isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        let languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
        this._router.navigate(['/' + isoCountryCode.toLowerCase() + '/' + languageCode.toLowerCase() + '/notfound',
            { skipLocationChange: true, queryParams: { returnUrl: returnUrl } }]);
    }
}
